import * as React from 'react';
import {
	Edit,
	EditProps,
	NumberInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { EDayOfWeek, ELanguage } from '../enums';
import TimeInput from "../components/TimeInput";

export const LiveTrainingEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="title" label="TITLE"/>
				<SelectInput step={1} source="dayOfWeek" label="DAY" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(EDayOfWeek).map(key => ({
					id: EDayOfWeek[key],
					name: EDayOfWeek[key]
				}))]}/>
				<TimeInput source="startHour" label="START_HOUR"/>
				<TimeInput source="endHour" label="END_HOUR"/>
				<TextInput type="url" step={1} source="link" label="LINK"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Edit>
	);
};
